import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { extensionDecorator, ExtensionPriority, NodeExtension, ExtensionTag, NodeGroup, setBlockType } from '@remirror/core';

var _dec, _class, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * The paragraph is one of the essential building blocks for a prosemirror
 * editor and by default it is provided to all editors.
 *
 * @core
 */

var ParagraphExtension = (_dec = /*#__PURE__*/extensionDecorator({
  defaultPriority: ExtensionPriority.Medium
}), /*#__PURE__*/_dec(_class = (_temp = class ParagraphExtension extends NodeExtension {
  constructor() {
    super(...arguments);

    _defineProperty(this, "extensionTags", [ExtensionTag.LastNodeCompatible]);
  }

  get name() {
    return 'paragraph';
  }

  createNodeSpec(extra) {
    return {
      content: 'inline*',
      group: NodeGroup.Block,
      attrs: _objectSpread({}, extra.defaults()),
      draggable: false,
      parseDOM: [{
        tag: 'p',
        getAttrs: node => _objectSpread({}, extra.parse(node))
      }],
      toDOM: node => {
        return ['p', extra.dom(node), 0];
      }
    };
  }
  /**
   * Provides the commands that this extension uses.
   */


  createCommands() {
    return {
      createParagraph: attributes => {
        return setBlockType(this.type, attributes);
      }
    };
  }

}, _temp)) || _class);

export { ParagraphExtension };
